import { HandoffState } from "@/models/chat.model";

import type { TMessageTone } from "./context";

export const MESSAGES_KEY = 'user_history';
export const MAX_MESSAGES_COUNT = 100;

export const HANDOFF_STATUS_COPY: Partial<Record<HandoffState, { tone: TMessageTone; text: string }>> = {
  [HandoffState.WAITING]: { tone: 'neutral', text: 'Looking for an available operator…' },
  [HandoffState.ATTENDED]: { tone: 'success', text: "You're now connected with an operator." },
  [HandoffState.ENDED]: { tone: 'neutral', text: 'The operator has left the chat — the assistant will take it from here.' },
  [HandoffState.CAPTURED]: { tone: 'warning', text: "No operators are available right now — we've received your message and will follow up." },
  [HandoffState.UNAVAILABLE]: { tone: 'danger', text: "Live chat handoff isn't available right now." },
};
